<template>
    <div>
        <!-- 面包屑导航 -->
        <el-breadcrumb separator-class="el-icon-arrow-right">
            <el-breadcrumb-item :to="{ path: '/Welcome' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path:'/insuranceSysTeamOrder'}">系统保险列表</el-breadcrumb-item>
            <el-breadcrumb-item>对公支付</el-breadcrumb-item>
        </el-breadcrumb>
        <!-- 卡片 -->
        <el-card class="box-card" style="margin-top:20px">
            <!-- 搜索  新增-->

            <!-- 车辆列表 -->
            <div id="printFrom">
                <!-- 保险列表 -->
                <el-table
                        ref="multipleTable"
                        :data="tableLoadData"
                        stripe
                        border
                        size="mini"
                        @selection-change="handleSelectionChange">
                    <el-table-column
                            type="selection"
                            align="center"

                            width="60">
                    </el-table-column>
                    <el-table-column

                            label="数量"
                            width="105"
                            prop="total_num"
                            :show-overflow-tooltip='true'>
                    </el-table-column>

                    <el-table-column

                            label="金额"
                            width="105"
                            prop="total_money"
                            :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column

                            label="保司"
                            width="105"
                            prop="corp_name"
                            :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column
                            label="投保人"
                            width="120"
                            prop="shop_name"
                            :show-overflow-tooltip='true'>
                    </el-table-column>
                    <el-table-column v-for="(x,y) in hdList"  :label="x.text" :key="y" >
                    <template slot-scope="scope">
                        <div v-for="(item,ind) in scope.row.data" :key="ind">
                            <span>
                            {{ item[x.val] }}
                            </span>
                        </div>
                    </template>
                    </el-table-column>

                    <el-table-column
                            label="操作"

                            width="150">
                        <template slot-scope="scope">
                            <el-button type="danger" size="mini"  @click="goPay(scope.row)">去支付</el-button>
                        </template>
                    </el-table-column>
                </el-table>

            </div>
            <!-- 分页 -->
            <div class="block" style="margin-top:10px">
                <el-pagination
                        background
                        @size-change="handleSizeChange"
                        @current-change="handleCurrentChange"
                        :current-page="page"
                        :page-sizes="[10, 20, 30, 100]"
                        :page-size="limit"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="total">
                </el-pagination>
            </div>
        </el-card>
        <!-- 新增编辑弹框 -->
        <el-dialog :title="title" :visible.sync="dialogFormVisible" width="70%">
            <el-form :model="form" :rules="rules" ref="form" label-width="110px">
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="日期" prop="name" size="small">
                            <el-input v-model="form.name" autocomplete="off" readonly></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="业务类别" prop="corporation" size="small">
                            <el-input v-model="form.corporation" autocomplete="off" readonly></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="经办人" size="small">
                            <el-input v-model="form.type" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="车号" prop="credit_code" size="small">
                            <el-input v-model="form.credit_code" autocomplete="off" readonly></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="车主" prop="" size="small">
                            <el-input v-model="form.incorporation_date" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :span="12">
                        <el-form-item label="金额" prop="" size="small">
                            <el-input v-model="form.registered_capital" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="12">
                        <el-form-item label="单号" prop="" size="small">
                            <el-input v-model="form.bank_account" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="24">
                    <el-col :span="24">
                        <el-form-item label="备注" size="small">
                            <el-input v-model="form.business_scope" type="textarea" autocomplete="off"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>

            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="reset_dialogForm('form')">取 消</el-button>
                <el-button type="primary" @click="submitForm('form')">确 定</el-button>
            </div>
        </el-dialog>
        <el-dialog title="图片" :visible.sync="uploadDialog" width="300px" style="line-height: 0;">
            <img style="width: 100%;height: 100%" :src="uploadImg" alt="" />
        </el-dialog>

        <ePay :payVisibleProp.sync="isShowPay" :orderInfoProp.sync="tmpOrder" :collectionPayinfo.sync="collectionPay" v-on:eventPay="choosePay"/>
      <!--<ePay :payVisibleProp.sync="isShowPay" :orderInfoProp.sync="multipleSelectionM" :collectionPayinfo.sync="collectionPay"  v-on:eventPay="choosePay" />-->
    </div>
</template>

<script>
    import table2excel from 'js-table2excel'
    import print from 'print-js'

    import eTable from "../common/eTable.vue";
    import moment from 'moment';    //日期时间转换
    import eInsurance from "../common/eInsurance";
    import ePay from "../common/ePay";
    import config from '../../utils/utils/config'
    export default {
        name: "payPublic",
        components: {
            eTable,
            eInsurance,
            ePay
        },
        props: {},
        data() {
            return {
                tmpOrder:{},
                collectionPay:{},
                hdList:[{text:'车牌号',val:'plate_number'},
                    {text:'产品',val:'product_name'},
                    {text:'保费',val:'real_price'}, //price
                    {text:'净费',val:'sell_price'}
                    ],
                isShowPay:false,
                shopList:[],

                isShowCar:false,
                // 搜索
                searchForm: {
                    name: '',
                    credit_code:'',
                    shop_id:'',
                },
                searchRules: {
                    name: [
                        { required: true, message: "请输入公司名称", trigger: "blur" },
                    ],
                },
                // 表头
                tableHeadConfig: [
                    {
                        label: "ID",
                        field: "id"
                    },

                    {
                        label: "产品名称",
                        field: "name"
                    },
                    {
                        label: "产品分类",
                        columnType: "slot",
                        slotName: "categoryName"
                    },
                    {
                        label: "创建时间",
                        columnType: "slot",
                        slotName: "addTime"
                    },
                    {
                        label: "备注",
                        field: "remark"
                    },
                    {
                        label: "操作",
                        columnType: "slot",
                        slotName: "operation",
                        width: 200
                    }
                ],
                // 数据
                tableLoadData: [],
                limit: 10,
                page:1,// 当前页码
                total:0,//总条目数
                id: '',
                rules: {
                    name: [{ required: true, message: '请输入公司名称', trigger: 'blur' }],
                    corporation: [{ required: true, message: '请输入法人', trigger: 'blur' }],
                    credit_code: [{ required: true, message: '请输入社会信用代码', trigger: 'blur' }],
                },
                dialogFormVisible: false,
                title: '',
                form: {
                    name: '',
                    address: '',
                    credit_code: '',
                    composition: '',
                    business_scope: '',
                    incorporation_date: '',
                    corporation: '',
                    registered_capital: '',
                    certificate_no: '',
                    lifespan: '',
                    issue_date: '',
                    type: '',
                    duty_paragraph: '',
                    mobile: '',
                    bank: '',
                    bank_account: '',
                },
                uploadImg: '',
                uploadDialog: false,
                orderIDs:[]
            };
        },
        created() {
          if(this.$route.query &&　this.$route.query.orderids) this.orderIDs = JSON.parse(this.$route.query.orderids);
          this.DataList()
        },
        mounted() {

        },
        filters: {
            statusFilter(status) {
                if (status == 1) {
                    return "启用";
                } else if (status == 2) {
                    return "禁用";
                }
            },
            //时间格式化
            dateFormat(add_time) {
                if (add_time == undefined) {
                    return "";
                }
                return moment(add_time*1000).format("yyyy-MM-DD HH:mm:ss");
            },

        },
        methods: {
            goPay(row){
              // 判断当前订单处理id是否存在
              this.isShowPay = true;
              ////console.log('tmpOrder----',row)
              this.tmpOrder = row
              //传 订单编号还有总价 过去
              let revlue =  config.setPuliceInfo(row)
              if(revlue.orderIDs )
              {
                //this.$set(this.tmpOrder,'total_money',revlue.total_money)
                this.$set(this.tmpOrder,'orderIDs',revlue.orderIDs)
              }
              //this.tmpOrder=row;
            },
            choosePay(val){
               this.isShowPay=false;
            },
            handleSelectionChange(val) {
                this.multipleSelection = val;
            },

            handelCancel(row){
                this.$confirm('请是否确认退保?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning',
                    callback: (action) => {
                        if (action === 'confirm') {
                            // const val = this.checkedDetail
                            // val.forEach((val, index) => {
                            //     this.tableData.forEach((v, i) => {
                            //         if (val.xh === v.xh) {
                            //             this.tableData.splice(i, 1)
                            //         }
                            //     })
                            // })
                            this.$message({
                                message: '操作成功！',
                                type: 'success'
                            })
                            //this.$refs.tb.clearSelection()

                        } else {
                            this.$message({
                                message: '已取消操作',
                                type: 'warning'
                            })

                        }
                    }
                })
            },
            //接收子组件传过来的值
            chooseCarInfo(car_number,...params){
                this.searchForm.name=car_number;
            },
            DataList(){
                const param = {
                    company_id:sessionStorage.getItem('company_id'),
                    access_token:sessionStorage.getItem('token'),
                    page: this.page,
                    pageSize:this.limit,
                }
                if(this.orderIDs) param.orderIDs = this.orderIDs
                this.$axios.getGroupPayList(param).then(res=>{
                    if(res.code == 200){
                        this.tableLoadData = res.data.data;
                        this.total = res.data.total
                    }else{
                      this.$message.error(res.msg);
                    }
                }).catch(error=>{
                    //console.log(error);
                })
            },
            // 设置每页条数
            handleSizeChange(newSize) {
                this.limit = newSize
                this.DataList()
            },
            // 分页跳转
            handleCurrentChange(newPage) {
                this.page = newPage
                this.DataList()
            },


        },

    };
</script>
<style>
    .table_name{
        font-weight: bold;
        /* border: 1px solid #f00; */
    }
    .table_name:hover{
        color: #409EFF;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/insurance/payPublic.vue